import {
  ALTERNANCE_MOBILITE,
  ENTREPRISE_FORMATION_CONTEXT,
  ENTREPRISE_NAME,
  financementOptions,
  REDIRECTION_ZOHO_LEAD
} from '@config/lists';
import {urlZohoLead} from '@config/constants';
import {retrieveUTMInURL} from "@actions/formulary";

/**
 * Sort form questions and slice it if necessesary
 *
 * startIndex attribute correspond to /?etape={int} in the url
 * or etape in the short_code or entryStep in the config
 *
 * @param {integer} startIndex
 * @param {*} array //list of pre configured question list
 * @returns [{index: , key: }]
 */
export const transformAndReorderForm = (startIndex, array) => {
  // On réordonne le formulaire en fonction de l'index de début de formulaire donné en argument
  // s'il existe (l'index de début) alors on décale les étapes, pour sauter celles précédent l'index lors de l'affichage
  // E.G. etapeDeDebut=2 alors on saute l'étape 1 dans le formulaire.
  const sortedArray = [...array].sort((a, b) => a.index - b.index);

  //TODO : Normalement on devrait les enlever des étapes visibles afin de ne pas permettre de revenir aux étapes précédentes
  return sortedArray
    .slice(startIndex)
    .map((item) => ({ index: sortedArray.indexOf(item) + 1, key: item.key }));

};

/**
 * retourner le host courant
 *
 * par exemple sur https://formations-secretaire-medicale.fr/ on aura formations-secretaire-medicale.fr
 * @returns string
 */
export const getCurrentHost = () => {
  if (window?.location?.hostname !== undefined) {
    return window.location.hostname;
  }
  console.error('Error getting current host: window or window.location is not available');
  return 'lecolefrancaise.fr';
};

/**
 * function qui retourne l'origin du site
 *
 * @returns string
 */
export const getCurrentOrigin = () => {
  try {
    return window.location.origin;
  } catch (error) {
    console.error('Error getting the current origin:', error);
    return 'https://lecolefrancaise.fr';
  }
};


//function to handle the click on step of the form
export const handleStep = (step, value, visibleSteps, setConfig) => {
  if (step === 'financement') {
    const selectedOption = financementOptions.find(option => option.id === value);
    let newVisibleSteps = handleStepCondition(step, selectedOption?.condition, visibleSteps);
    setConfig({
      visibleSteps: newVisibleSteps,
      maxStep: newVisibleSteps.length,
    });
    return newVisibleSteps;
  }
  return visibleSteps;
};

//ici on gère le la condition présente dans une option de l'etape
// pour l'instant ça sert surtout dans le cas du financement
const handleStepCondition = (step, condition, newVisibleSteps) => {

  switch (condition) {
    case REDIRECTION_ZOHO_LEAD : {
        const queryString = window.location.search ? window.location.search + '&' : '?';
        window.location.href = urlZohoLead + queryString + retrieveUTMInURL() + '&origine=bitrix';
        break;
    }

  // TODO: vérifier si toujours un besoin et supprimer le cas échéant
  case 'dateOfBirth': {
    const keysToRemove = [ENTREPRISE_FORMATION_CONTEXT, ENTREPRISE_NAME];
    newVisibleSteps = removeElementsByKeys(newVisibleSteps, keysToRemove);

    if (newVisibleSteps.findIndex((elem) => elem.key === condition) === -1) {

      let indexOfFinancement = newVisibleSteps.findIndex(
        (elem) => elem.key === step
      );

      newVisibleSteps.splice(indexOfFinancement + 1, 0, { index: 9, key: condition });

    }
    if (newVisibleSteps.findIndex((elem) => elem.key === ALTERNANCE_MOBILITE) === -1) {

      let indexOfFinancement = newVisibleSteps.findIndex(
        (elem) => elem.key === step
      );

      newVisibleSteps.splice(indexOfFinancement + 1, 0, { index: 10, key: ALTERNANCE_MOBILITE });

    }
    break;
  }

  case ENTREPRISE_FORMATION_CONTEXT: {

      //remove date of birth when click on entreprise
    const keysToRemove = ['dateOfBirth', ALTERNANCE_MOBILITE];
    newVisibleSteps = removeElementsByKeys(newVisibleSteps, keysToRemove);

    if (newVisibleSteps.findIndex((elem) => elem.key === condition) === -1) {


      let indexOfFinancement = newVisibleSteps.findIndex(
        (elem) => elem.key === step
      );

      //add the two steps
      newVisibleSteps.splice(indexOfFinancement + 1, 0, { index: 7, key: condition });
      newVisibleSteps.splice(indexOfFinancement + 2, 0, { index: 8, key: ENTREPRISE_NAME });

    }
  }

    break;
  default: {

      if (step === 'financement') {
      //remove all specific steps when their options are not selected
      const keysToRemove = ['dateOfBirth', ENTREPRISE_FORMATION_CONTEXT, ENTREPRISE_NAME, ALTERNANCE_MOBILITE];
      newVisibleSteps = removeElementsByKeys(newVisibleSteps, keysToRemove);

    }

    break;
  }

  }
  return newVisibleSteps;
};


// Utility function to remove elements by keys and re-index the array
const removeElementsByKeys = (array, keysToRemove) => {
  return array.filter(item => !keysToRemove.includes(item.key));
};


